import InformacionD from "./InformacionD";
import InformacionI from "./InformacionI";
import InformacionImagen from "../../img/imgaside/informacion1.JPG";
import InformacionImagen2 from "../../img/imgaside/distingue.jpg";
import InformacionImagen3 from "../../img/imgaside/conocenos.jpg";
import InformacionImagen4 from "../../img/imgaside/servicios.jpg";

function Principal() {
    return (
      <>
        <main>
          <InformacionD titulo={'Que hacemos'} informacion={'Somos un taller automotriz especializado en el diagnóstico y reparación de una amplia gama de fallas mecánicas. Contamos con un equipo altamente calificado que puede abordar problemas que van desde transmisiones y motores hasta complicaciones eléctricas y de suspensión, entre otros.'} children={InformacionImagen} children2={"imagen de aside numero 1"}>
      
          </InformacionD>
      
          <InformacionI titulo={'Lo que nos distinge de los demas'} informacion={'Disponemos de una amplia variedad de herramientas que potencian aún más nuestras capacidades de servicio, contribuyendo a mejorar tanto la eficiencia como la calidad del trabajo que ofrecemos a nuestros clientes.'} children={InformacionImagen2} children2={"imagen de aside numero 1"}>
      
          </InformacionI>
      
      
          <InformacionD titulo={'Conocenos mas'} informacion={'Si está interesado en nuestros servicios, lo invitamos a visitarnos. Estamos ubicados en la Calle 1ro. de Mayo, detrás del OXXO en Damu, que se encuentra en la avenida principal de Cruz Azul - Jasso / Cruz Azul - San Marcos. También puede Ubicarnos fácilmente utilizando Google Maps pulsando '} vinculo={"https://maps.app.goo.gl/vrE7zFQVfXAhXBDp7"} infov={'Aquí.'} children={InformacionImagen3} children2={"imagen de aside numero 1"}>
      
          </InformacionD>
      
          <InformacionI titulo={'Servicios'} informacion={"Ofrecemos una amplia variedad de servicios, que incluyen la reparación de motores, transmisiones automáticas, suspensión, frenos, entre otros. Para obtener más información detallada, le invitamos a consultar la sección de "} vinculo={"/Service/2"} infov={" 'Servicios'"} children={InformacionImagen4} children2={"imagen de aside numero 1"}> 
      
          </InformacionI>
        </main>
      </>
    );
  };
  
  export default Principal;
  